export default __webpack_public_path__ + "static/media/office.bd51edd1.jpg";